import { serviceRequest, UpdateRequestStatus } from '../api/endpoints'
import { authCall } from '.'
import useSWR from 'swr'
import { CustomPaginationQuery, ServiceRequestsResponse } from '../interfaces/services'

interface ServiceListQuery extends CustomPaginationQuery {
  serviceId?: string
  query?: string
  limit?: number
  status?: string
  estateId?: string
}

const ServiceRequest = {
  useGetServiceRequests: ({ 
  page = 1, 
  limit = 10,  
  serviceId,
  status,
  estateId
}: ServiceListQuery) => {

  let url = `${serviceRequest}?page=${page}&limit=${limit}`
  
  if (serviceId) {
    url += `&serviceId=${serviceId}`
  }
  
  if (status && status !== 'all') {
    url += `&status=${status}`
  }

  if (estateId) {
    url += `&estateId=${estateId}`
  }

  return useSWR<ServiceRequestsResponse>(
    url,
    async () => {
      const res = await authCall<ServiceRequestsResponse>({ 
        url, 
        method: 'get' 
      })
      return res
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      revalidateOnReconnect: true,
      dedupingInterval: 2000,
    }
  )
},

  assignArtisan: async (requestId: string, artisanId: string) => {
    const url = `${serviceRequest}/${requestId}/assign-artisan`
    const res = await authCall<{ message: string }>({
      url,
      method: 'patch',
      data: { artisanId },
    })
    return res
  },

  cancelRequest: async (requestId: string) => {
    const url = `${serviceRequest}/${requestId}/cancel`
    const res = await authCall<{ message: string }>({
      url,
      method: 'patch',
    })
    return res
  },

updateRequestStatus: async (requestId: string, status: string) => {
  const url = UpdateRequestStatus(requestId)
  const res = await authCall<{ message: string }>({
    url,
    method: 'patch',
    data: { status },  // ← was missing
  })
  const maybe = res as any
  return maybe.data ?? res
},
}

export default ServiceRequest